import React from 'react'

export default function MonthlyAttendanceMonthNav({
  monthKey = '2026-08',
  onMonthChange,
  onPrevMonth,
  onNextMonth,
  onCurrentMonth,
  onLastMonth,
  totalDays = 31,
  workingDays = 26,
}) {
  const [yearStr, monthStr] = monthKey.split('-')
  const dateObj = new Date(parseInt(yearStr, 10), parseInt(monthStr, 10) - 1, 1)
  const formattedMonth = dateObj.toLocaleDateString('en-GB', {
    month: 'long',
    year: 'numeric',
  })

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-outline-variant/25 bg-surface-container-lowest p-4 shadow-xs">
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-xs font-black uppercase tracking-wider text-on-surface-variant">
          Attendance Month:
        </span>

        {/* Stepper Group */}
        <div className="flex items-center gap-1">
          <button
            type="button"
            onClick={onPrevMonth}
            title="Previous Month"
            className="flex h-9 w-9 items-center justify-center rounded-xl border border-outline-variant/30 bg-surface-container-low text-on-surface hover:bg-surface-container hover:text-primary transition cursor-pointer"
          >
            <span className="material-symbols-outlined text-base">chevron_left</span>
          </button>

          <div className="relative">
            <input
              type="month"
              value={monthKey}
              onChange={(e) => onMonthChange(e.target.value)}
              className="h-9 w-44 rounded-xl border border-outline-variant/30 bg-surface-container-low px-3 text-xs font-black text-on-surface outline-none focus:border-primary text-center cursor-pointer"
            />
          </div>

          <button
            type="button"
            onClick={onNextMonth}
            title="Next Month"
            className="flex h-9 w-9 items-center justify-center rounded-xl border border-outline-variant/30 bg-surface-container-low text-on-surface hover:bg-surface-container hover:text-primary transition cursor-pointer"
          >
            <span className="material-symbols-outlined text-base">chevron_right</span>
          </button>
        </div>

        {/* Quick Month Presets */}
        <div className="flex items-center gap-1.5 ml-1">
          {/* <button
            type="button"
            onClick={onLastMonth}
            className="rounded-xl border border-outline-variant/20 bg-surface-container-low px-3 py-1.5 text-xs font-bold text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition cursor-pointer"
          >
            Last Month
          </button> */}
          <button
            type="button"
            onClick={onCurrentMonth}
            className="rounded-xl border border-primary/30 bg-primary/10 px-3 py-1.5 text-xs font-bold text-primary hover:bg-primary/20 transition cursor-pointer"
          >
            Current Month
          </button>
        </div>
      </div>

      {/* <div className="flex items-center gap-3 text-xs font-extrabold text-on-surface">
        <span className="flex items-center gap-1.5 text-primary">
          <span className="material-symbols-outlined text-base">calendar_month</span>
          <span>{formattedMonth}</span>
        </span>
        <span className="inline-flex items-center gap-1 rounded-xl bg-surface-container-high px-2.5 py-1 text-[11px] font-bold text-on-surface-variant">
          {totalDays} Days ({workingDays} Working)
        </span>
      </div> */}
    </div>
  )
}
